export function serializeFormData(form) {
  const data = {};
  const elements = form.querySelectorAll('input, select, textarea');
  elements.forEach(el => {
    if (el.name) data[el.name] = el.type === 'checkbox' ? el.checked : el.value;
  });
  return data;
}

// Helper to build nested objects for form data being sent to the backend
// extension of https://silvantroxler.ch/2018/object-string-property-nesting/
// supports both nested objects and arrays
// logic does not support if nested object has keys that are numbers
export function formattedFormData(form) {
  if (!form) {
    return {};
  }
  const nestFormProperties = formObj => Object.entries(formObj)
    .reduce((result, [property, val]) => {
      property.split('.')
        .reduce((nestedResult, prop, propIndex, propArray) => {
          const lastProp = propIndex === propArray.length - 1;
          if (lastProp) {
            nestedResult[prop] = val;
            return nestedResult[prop];
          }
          // if int is seen in flattened path, will create an array else defaults to object
          nestedResult[prop] = nestedResult[prop]
            || (nestedResult[prop] = (!isNaN(parseInt(propArray[propIndex + 1], 10)) ? [] : {}));
          return nestedResult[prop];
        }, result);
      return result;
    }, {});
  return nestFormProperties(form);
}
